export interface IBulkUploadResponsible {
  firstName: string;
  lastName: string;
  email: string;
  avatar: string;
}

export interface IBulkUploadLoadStatus {
  success: number;
  total: number;
  typeOfCharge: string;
}

export interface IBulkUploadHistoryItem {
  date: string;
  loadId: number;
  category: string;
  responsible: IBulkUploadResponsible;
  loadStatus: IBulkUploadLoadStatus;
  template: string;
}

export interface IBulkUploadApi {
  id: number;
  bulkUploadTypeId: number;
  exchangeId: number;
  userId: number | null;
  fileUrl: string;
  errorFileUrl: string | null;
  response: string | null;
  productsUploaded: number;
  productsUpdated: number;
  createdAt: string;
  updatedAt: string;
  deletedAt: string | null;
  bulkUploadType: IBulkUploadApiType;
  exchange: IBulkUploadApiExchange;
}

export interface IBulkUploadCatalogApi extends IBulkUploadApi {
  exchangeId: number;
  productsUploaded: number;
  productsUpdated: number;
  exchange: IBulkUploadApiExchange;
}

export interface IBulkUploadOrderApi extends IBulkUploadApi {
  totalRecords: number;
  createdRecords: number;
}

export interface IBulkUploadQuotesApi extends IBulkUploadApi {
  totalRecords: number;
  createdRecords: number;
}

export interface IBulkUploadApiType {
  id: number;
  name: string;
  description: string;
}

export interface IBulkUploadApiExchange {
  id: number;
  country: string;
  countryStringId: string;
  flag: string;
}

export enum BULK_UPLOAD_TYPE_ID {
  CATALOG = 1,
  ORDERS = 2,
  QUOTES = 3
}

export const BULK_UPLOAD_TYPE_NAME = {
  [BULK_UPLOAD_TYPE_ID.CATALOG]: 'Catálogo',
  [BULK_UPLOAD_TYPE_ID.ORDERS]: 'Órdenes',
  [BULK_UPLOAD_TYPE_ID.QUOTES]: 'Cotizaciones'
};
